module.exports = __webpack_public_path__ + "static/devtomaterial-ceaa3f2a38fb5af186aa378d16bac035.png";